import React, { useState } from 'react';

// Types
import { UpdateAiReportBodyItemType } from 'Shared/types/UpdateAiReportType.type';

// Utils
import { editorStateToJsonString } from 'Wpds/components/rich-text/utils/EditorState.utils';

// Components
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpRichTextInput } from 'Wpds/components/rich-text';

// Styles
import './ReportPageSection.scss';

type Props = {
  section: UpdateAiReportBodyItemType;
  isEditing: boolean;
  handleUpdate: Function;
};

const ReportPageSection = ({ section, isEditing, handleUpdate }: Props) => {
  const [title, setTitle] = useState(section.title);
  const [body, setBody] = useState(section.sectionBody);

  const handleUpdateTitle = (value: string) => {
    setTitle(value);
    handleUpdate({
      body: [{ template_section_slug: section.templateSectionSlug, title: value }],
    });
  };

  const handleUpdateBody = value => {
    setBody(value);
    handleUpdate({
      body: [{ template_section_slug: section.templateSectionSlug, section_body: editorStateToJsonString(value) }],
    });
  };

  const baseClassName = 'ReportPageSection';
  return (
    <div className={baseClassName}>
      {isEditing ? (
        <div className={`${baseClassName}__title--edit`}>
          <WpTextField
            id={`section_title-${section.templateSectionSlug}`}
            name="title"
            label="Section Title"
            placeholder="Section Title"
            value={title}
            labelHidden
            max={50}
            onChange={handleUpdateTitle}
          />
        </div>
      ) : (
        <h4>{title}</h4>
      )}

      <WpRichTextInput
        options={{ showBorder: false }}
        value={body}
        height="auto"
        readOnly={!isEditing}
        onChange={handleUpdateBody}
      />
    </div>
  );
};

export default ReportPageSection;
